import styled from 'styled-components';
import { ISliderArrowProps } from './SliderArrow';

const StyledArrow = styled.span`
  --arrow-size: 14px;
  left: 30%;
  position: absolute;
  bottom: 0;
  margin-left:0px;
  width: var(--arrow-size);
  height: var(--arrow-size);
  background-size: contain;
  top: calc((var(--arrow-button-size) - var(--arrow-size) - 4px) / 2);
  background-image: var(--color-arrow-bg);

  animation-name: bounceAlpha;
  animation-duration:1.4s;
  animation-iteration-count:infinite;
  animation-timing-function:linear;
`;

export const StyledPrimaryArrow = styled(StyledArrow)`
  animation-name: bounceAlpha;
  animation-duration:1.4s;
  animation-delay:0.2s;
  animation-iteration-count:infinite;
  animation-timing-function:linear;
`;
export const StyledSecondaryArrow = styled(StyledArrow)`
  margin-left: 8px;
`;


export const StyledRound = styled.button`
  --arrow-button-size: 50px;
  cursor: pointer;
  z-index: 999;
  position: absolute;
  /* top: calc(50vh - 20px); */
  bottom: 50px;
  background: var(--color-body);
  transition: background var(--theme-transition-duration);
  padding: 0;
  outline: none;
  border: none;
  width: var(--arrow-button-size);
  height: var(--arrow-button-size);

  &[data-direction=prev] {
    left: calc(50% - var(--arrow-button-size) / 2 - 50px);
    border-top: 3px solid var(--color-primary);
    transform: rotate(180deg);
  }

  &[data-direction=next] {
  border-bottom: 3px solid var(--color-primary);
    left: calc(50% - var(--arrow-button-size) / 2 + 50px);
  }

  &:disabled {
    opacity: .3;
  }

  @keyframes bounceAlpha {
    0% {opacity: 1; transform: translateX(0px) scale(1);}
    25%{opacity: 0; transform:translateX(10px) scale(0.9);}
    26%{opacity: 0; transform:translateX(-10px) scale(0.9);}
    55% {opacity: 1; transform: translateX(0px) scale(1);}
  }

  &:hover {
    ${StyledArrow} {
      animation-name: bounceAlpha;
      animation-duration:1.4s;
      animation-iteration-count:infinite;
      animation-timing-function:linear;
    }
    
    ${StyledPrimaryArrow} {
      animation-name: bounceAlpha;
      animation-duration:1.4s;
      animation-delay:0.2s;
      animation-iteration-count:infinite;
      animation-timing-function:linear;
    }
  }
`;